import React from 'react';

const AssignViewOwnProfileContext = React.createContext(false);

export default AssignViewOwnProfileContext;
